import { PersonaInfoSummary } from '@/therapist/pages/tasks/types/Task'

import { axios, Response } from '../index'
import { FolderVisibility } from '../templatesArquive/create-template'

export interface Body {
  name: string
  parentFolderId?: string | null
}

export type PermissionInsideFolder = 'EDIT' | 'VISUALIZATION'

export type FolderPermissionFolder = {
  folderId: string
  folderPersonPermissionId: string
  permissionInsideFolder: PermissionInsideFolder
  personaInfoSummary: PersonaInfoSummary
}

export type AccessProfilePermissionResponse = {
  id: string
  profile: {
    id: number
    name: string
    personaType: string
  }
  permissionInsideFolder: PermissionInsideFolder
}

export type PersonaFolder = {
  id: string
  name: string
  folderVisibility: FolderVisibility
  parentFolderId: string
  createdAt: string
  updatedAt: string
  uploadBy: PersonaInfoSummary
  permissions: FolderPermissionFolder
  accessProfilePermissions: AccessProfilePermissionResponse
}

export default async function uploadFiles(
  personaId: string,
  body: Body
): Response<PersonaFolder> {
  return await axios.post(`/v1/personas/${personaId}/folders`, body)
}
